import { API_JWT_SIGNATURE_PATH, getClient } from '../api';

export async function createJWTSignature(payload: { [key: string]: any }): Promise<string> {
  const client = await getClient();
  const { data } = await client.post<{ jwt: string }>(API_JWT_SIGNATURE_PATH, payload);

  return data.jwt;
}
